import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import TextTruncate from 'react-text-truncate';
import { isArray, get } from 'lodash';

class RowItemKetQuaTraCuu extends React.Component {

  showThongTinCongDan() {
    let size = this.props.item.listNguoiDungDon.length;
    if (size) {
      return (
        <div>
          <li className="txt-bold">{this.props.item.listNguoiDungDon[0].hoVaTen}</li>
          <li>{this.getLocal(this.props.item.listNguoiDungDon[0])}</li>
          <li>{this.props.item.listNguoiDungDon[0].soDienThoai}</li>
        </div>
      )
    }
  }

  showThoiHanXuLyDon(thoiHanXuLy) {
    if (thoiHanXuLy.type == 'DAY') {

      if (thoiHanXuLy.value == 0) {
        return (
          <p style={{ color: "#E9573F" }}>Hết hạn</p>
        )
      } else if (thoiHanXuLy.value > 0) {
        return (
          <p>Còn {thoiHanXuLy.value} ngày</p>
        )
      } else {
        return (
          <p style={{ color: "#E9573F" }}>Trễ {Math.abs(thoiHanXuLy.value)} ngày</p>
        )
      }
    } else if (thoiHanXuLy.type == 'TIME') {
      return (
        <p style={{ color: "#E9573F" }}>Còn {thoiHanXuLy.value}</p>
      )
    }
  }

  showCanBoDangXuLy() {

    this.props.item.canBoDangXuLyInfo.filter(item => {
      return item.donViId == this.props.userInfo.donViId;
    }).map((child, i) => {
      if (child.hoVaTen != "")
        this.setState({
          canBoXuLy: child.hoVaTen
        })
    })
  }

  getLocal(data) {
    let address = [];
    if(data) {
      if(data.diaChi) {
        address.push(data.diaChi);
      }
      if(data.toThon) {
        address.push(data.toThon);
      }
      if(data.phuongXaCongDan && data.phuongXaCongDan.ten) {
        address.push(data.phuongXaCongDan.ten);
      }
      if(data.quanHuyenCongDan && data.quanHuyenCongDan.ten) {
        address.push(data.quanHuyenCongDan.ten);
      }
      if(data.tinhThanhCongDan && data.tinhThanhCongDan.ten) {
        address.push(data.tinhThanhCongDan.ten);
      }
    }
    return address.join(", ");
  }

  checkNguonDon(type) {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let nguonDonText = '';
    let nguonDonDonVi = '';
    let nguonDontype = '';
    let Return = '';
    if (this.props.item.nguonDonInfo) {
      let dataNguonDon = isArray(this.props.item.nguonDonInfo) && this.props.item.nguonDonInfo.filter(nguonDon => {
        return nguonDon.idDonVi == userInfo.donViId;
      });
      if (dataNguonDon.length > 0) {
        nguonDonText = dataNguonDon[0].nguonDonText;
        nguonDonDonVi = dataNguonDon[0].donViChuyenText;
        nguonDontype = dataNguonDon[0].type;
      } else if (this.props.isDonCu) {
        nguonDonText = get(this.props.item, 'nguonDonInfo.ten')
      } else {
        nguonDonText = this.props.item.nguonDonText;
        nguonDonDonVi = '';
        nguonDontype = '';
      }
    }
    if (type === 'nguonDonText') {
      Return = nguonDonText
    }
    if (type === 'nguonDonDonVi') {
      Return = nguonDonDonVi
    }
    if (type === 'nguonDontype') {
      Return = nguonDontype
    }
    return Return;
  }

  render() {
    let donDate = this.props.item.ngayTiepNhanDon ? moment(this.props.item.ngayTiepNhanDon).format('DD/MM/YYYY') : '';
    let donTime = this.props.item.ngayTiepNhanDon ? moment(this.props.item.ngayTiepNhanDon).format('HH:mm') : '';
    let nguonDonText = this.checkNguonDon('nguonDonText');
    let nguonDonDonVi = this.checkNguonDon('nguonDonDonVi');
    const loaiDon = () => {
      let tenLoaiDon = '';
      if (this.props.isDonCu) {
        tenLoaiDon = get(this.props.item, 'loaiDonInfo.ten');
      }
      if (this.props.item.loaiDonThuInfo) {
        tenLoaiDon = get(this.props.item, 'loaiDonThuInfo.ten');
      }
      return tenLoaiDon;
    }
    return (
      <tr>

        <td>{this.props.count}</td>
        {
          !this.props.isDonCu &&
          <td>{this.props.item.maHoSo || ''}</td>
        }
        {
          !this.props.isDonCu && 
          <td>
            <ul className="list-items-table">
              <li>{donDate}</li>
              <li>{donTime}</li>
            </ul>
          </td>
        }

        <td>
          <ul className="list-items-table">
            {this.showThongTinCongDan()}
          </ul>
        </td>

        <td>
          <ul className="list-items-table">
            <li>
              {
                this.props.isDonCu ?
                <Link
                  className="txt-underline"
                  to={{ 
                    pathname: `/chi-tiet-don-cu/${get(this.props.item, 'donCuId')}`, 
                    state: { phamVi: this.props.phamVi} 
                  }}>
                  <TextTruncate
                    line={3}
                    truncateText="…"
                    text={this.props.item.noiDung}
                    />
                </Link> :
                <Link
                  className="txt-underline"
                  to={{ 
                    pathname: `/chi-tiet-tra-cuu/${get(this.props.item, 'maHoSo')}`, 
                    state: { phamVi: this.props.phamVi} 
                  }}>
                  <TextTruncate
                    line={3}
                    truncateText="…"
                    text={this.props.item.noiDung}
                    />
                </Link>
              }
            </li>
            {
              this.props.item.trangThaiDonType !== 'DA_XU_LY' && this.props.item.trangThaiDonType !== 'DA_GIAI_QUYET' && this.props.item.thoiHanInfo ?
                <li>
                  {this.showThoiHanXuLyDon(this.props.item.thoiHanInfo)}
                </li>
              : ''
            }
          </ul>
        </td>

        <td>
          <ul className="list-items-table">
            <li>
              {loaiDon()}
            </li>
            <li>{this.props.item.soNguoi ? (this.props.item.soNguoi + ' người') : ''}</li>
          </ul>
        </td>

        <td>
          {
            this.props.phamVi === 'SCOPE' ?
              <ul className="list-items-table">
                {(nguonDonDonVi !== '' && nguonDonDonVi !== null) &&
                  <li className="txt-italic">{nguonDonDonVi}</li>
                }
                <li>{nguonDonText}</li>
              </ul>
            :
              <ul className="list-items-table">
                <li>{this.props.isDonCu ? get(this.props.item, 'nguonDonInfo.ten') : get(this.props.item, 'nguonDon')}</li>
              </ul>
          }
        </td>
      </tr>
    )
  }
}

let bindStateToProps = state => {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  }
}

export default connect(bindStateToProps)(RowItemKetQuaTraCuu);



// WEBPACK FOOTER //
// ./src/components/modules/tra-cuu/RowItemKetQuaTraCuu.jsx